import { TTemplate } from '@/interfaces/offer'

export const TEMPLATE_OPTION = {
  [TTemplate.SONG_WRITER]: '作曲家',
  [TTemplate.LYRICIST]: '作詞家',
  [TTemplate.ARRANGER]: '編曲家',
  [TTemplate.MUSICIAN]: 'ミュージシャン',
  [TTemplate.RECORDING_STUDIO]: 'レコーディングスタジオ',
  [TTemplate.MIX_ENGINEER]: 'ミックスエンジニア',
  [TTemplate.MASTERING_ENGINEER]: 'マスタリングエンジニア',
  [TTemplate.MIX_MASTERING_ENGINEER]: 'ミックス＆マスタリングエンジニア',
}

export const TEMPLATES = {
  [TTemplate.SONG_WRITER]: `こんにちは。（職業名など）の、〇〇と申します。
この度は、楽曲制作のご相談をしたくご連絡致しました。

【依頼したい作業内容】
〇〇に使用する楽曲の作曲をお願いしたいです。

【依頼する楽曲の詳細情報】
歌詞はできて（います/いません/インストです）

【完成楽曲の利用用途】
サブスクなどで配信/ YouTubeやSNSで配信/CDにして販売 /ライブで使用/個人的に楽しむため

【仕上げて欲しい楽曲の方向性】
・楽曲のテーマ：
・リファレンス曲：
・ジャンル：
・楽曲の長さ：
・ヴォーカルレンジ：
・その他希望：

【希望納期】
〇月〇日データ納品

【納品して欲しいデータ】
・データ内容：
・ファイル形式：
・サンプルレート：

【添付ファイル説明（ファイル名をご記入ください）】

【予算】

【その他詳細条件（ご希望条件をお書き下さい）】
・打ち合わせ希望：
・打合せ回数：
・想定時間：
・打合せ方法（リモート、対面など）：
・その他：

以上、ご返事お待ちしております。`,
  [TTemplate.LYRICIST]: `こんにちは。（職業名など）の、〇〇と申します。
この度は、楽曲制作のご相談をしたくご連絡致しました。

【依頼したい作業内容】
オリジナル楽曲の作詞をお願いしたいです。

【依頼する楽曲の詳細情報】
・作曲はできて（います/いません）
・楽曲の構成：

【完成楽曲の利用用途】
サブスクなどで配信/ YouTubeやSNSで配信/CDにして販売 /ライブで使用/個人的に楽しむため

【仕上げて欲しい歌詞の方向性】
・楽曲のテーマ：
・歌詞のテーマや伝えたいこと：
・リファレンス曲：
・その他希望：

【希望納期】
〇月〇日データ納品

【納品して欲しいデータ】
・データ内容：　
・ファイル形式：

【添付ファイル説明（ファイル名をご記入ください）】

【予算】

【その他詳細条件（ご希望条件をお書き下さい）】
・打ち合わせ希望：
・打合せ回数：
・想定時間：
・打合せ方法（リモート、対面など）：
・その他：

以上、ご返事お待ちしております。`,
  [TTemplate.ARRANGER]: `こんにちは。（職業名）、〇〇と申します。
この度は、楽曲制作のご相談をしたくご連絡致しました。

【依頼したい作業内容】
弾き語りで作った曲の編曲をお願いしたいです。

【依頼する楽曲の詳細情報】
・BPM：
・楽曲の長さ：
・現時点での仕上がり具合：

【完成楽曲の利用用途】
サブスクなどで配信/ YouTubeやSNSで配信/CDにして販売 /ライブで使用/個人的に楽しむため

【仕上げて欲しい楽曲の方向性】
・リファレンス曲：
・その他希望：

【希望納期】
〇月〇日データ納品

【納品して欲しいデータ】
・データ内容：
・ファイル形式：
・サンプルレート：

【添付ファイル説明（ファイル名をご記入ください）】

【予算】

【その他詳細条件（ご希望条件をお書き下さい）】
・打ち合わせ希望：
・打合せ回数：
・想定時間：
・打合せ方法（リモート、対面など）：
・その他：

以上、ご返事お待ちしております。`,
  [TTemplate.MUSICIAN]: `こんにちは。（職業名）、〇〇と申します。
この度は、楽曲制作のご相談をしたくご連絡致しました。

【依頼したい作業内容】
打ち込みで制作中の楽曲に生演奏を入れていただきたいです。

【依頼する楽曲の詳細情報】
・BPM：
・楽曲の長さ：
・現時点での仕上がり具合：

【完成楽曲の利用用途】
サブスクなどで配信/ YouTubeやSNSで配信/CDにして販売 /ライブで使用/個人的に楽しむため

【演奏の方向性】
・楽曲コンセプト：
・リファレンス曲：
・その他希望：

【希望納期】
〇月〇日データ納品

【納品して欲しいデータ】
・データ内容：
・ファイル形式：
・サンプルレート：

【添付ファイル説明（ファイル名をご記入ください）】

【予算】

【その他詳細条件（ご希望条件をお書き下さい）】
・打ち合わせ希望：
・打合せ回数：
・想定時間：
・打合せ方法（リモート、対面など）：
・その他：

以上、ご返事お待ちしております。`,
  [TTemplate.RECORDING_STUDIO]: `こんにちは。（職業名）、〇〇と申します。
この度は、楽曲制作のご相談をしたくご連絡致しました。

【依頼したい作業内容】
バンド演奏でレコーディングをしたいのでスタジオを借りたいです。

【希望利用時期】
⚪︎月中旬〜⚪︎月下旬

【希望利用時間】
⚪︎時間〜⚪︎時間

【録音予定の楽器】

【エンジニア】
エンジニア依頼希望 ：エンジニアも依頼したい / 乗り込み
依頼する場合の作業内容：レコーディングのみ / ミックスまで

【完成楽曲の利用用途】
サブスクなどで配信/ YouTubeやSNSで配信/CDにして販売 /ライブで使用/個人的に楽しむため

【添付ファイル説明（ファイル名をご記入ください）】

【予算】

【その他詳細条件（ご希望条件をお書き下さい）】
・打ち合わせ希望：
・打合せ回数：
・想定時間：
・打合せ方法（リモート、対面など）：
・その他：

以上、ご返事お待ちしております。`,
  [TTemplate.MIX_ENGINEER]: `こんにちは。（職業名など）の、〇〇と申します。
この度は、楽曲制作のご相談をしたくご連絡致しました。

【依頼したい作業内容】
レコーディング済みのバンド演奏をミックスしていただきたいです。

【依頼する楽曲の詳細情報】
・トラック数：
・BPM：
・楽曲の長さ：
・サンプルレート：

【完成楽曲の利用用途】
サブスクなどで配信/ YouTubeやSNSで配信/CDにして販売 /ライブで使用/個人的に楽しむため

【仕上げて欲しい楽曲の方向性】
・楽曲のテーマ：
・リファレンス曲：

【希望納期】
〇月〇日指定ファイル形式でデータ納品

【納品して欲しいデータ】
・データ内容：
・ファイル形式：
・サンプルレート：

【添付ファイル説明（ファイル名をご記入ください）】

【予算】

【その他詳細条件（ご希望条件をお書き下さい）】
・打ち合わせ希望：
・打合せ回数：
・想定時間：
・打合せ方法：
・その他：

以上、ご返事お待ちしております。`,
  [TTemplate.MASTERING_ENGINEER]: `こんにちは。（職業名など）の、〇〇と申します。
この度は、楽曲制作のご相談をしたくご連絡致しました。

【依頼したい作業内容】
ミックス済み音源のマスタリングをお願いしたいです。

【依頼する楽曲の詳細情報】
・曲数：
・総演奏時間：
・サンプルレート：

【完成楽曲の利用用途】
サブスクなどで配信/ YouTubeやSNSで配信/CDにして販売 /ライブで使用/個人的に楽しむため

【仕上げて欲しい楽曲の方向性】
・楽曲のテーマ：
・リファレンスアルバム：

【希望納期】
〇月〇日指定ファイル形式でデータ納品

【納品して欲しいデータ】
・データ内容：（ CD、データ、両方など）
・ファイル形式：

【添付ファイル説明（ファイル名をご記入ください）】

【予算】

【その他詳細条件（ご希望条件をお書き下さい）】
・打ち合わせ希望：
・打合せ回数：
・打合せ方法：
・その他：

以上、ご返事お待ちしております。`,
  [TTemplate.MIX_MASTERING_ENGINEER]: `こんにちは。（職業名など）の、〇〇と申します。
この度は、楽曲制作のご相談をしたくご連絡致しました。

【依頼したい作業内容】
レコーディング済みのバンド演奏のミックス・マスタリングをお願いしたいです。

【依頼する楽曲の詳細情報】
・曲数：
・トラック数：
・BPM：
・楽曲の長さ：
・サンプルレート：

【完成楽曲の利用用途】
サブスクなどで配信/ YouTubeやSNSで配信/CDにして販売 /ライブで使用/個人的に楽しむため

【仕上げて欲しい楽曲の方向性】
・楽曲のテーマ：
・リファレンス曲：

【希望納期】
〇月〇日指定ファイル形式でデータ納品

【納品して欲しいデータ】
・データ内容：（ CD、データ、両方など）
・ファイル形式：
・サンプルレート：

【添付ファイル説明（ファイル名をご記入ください）】

【予算】

【その他詳細条件（ご希望条件をお書き下さい）】
・打ち合わせ希望：
・打合せ回数：
・打合せ方法：
・その他：

以上、ご返事お待ちしております。`,
}